import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import type { CustomInfoProps } from '../HotelTile.types';
import { TextEllipsisWrapper } from '@shared/utils/formatting/textEllipsis';

export const CustomInfo: React.FC<CustomInfoProps> = React.memo(({ lines }) => {
  const filtered = lines.filter(Boolean);
  if (filtered.length === 0) return null;

  return (
    <Flex
      flexDirection="column"
      gap={1}
      minWidth={0}
    >
      {filtered.map((line, index) => (
        <TextEllipsisWrapper
          key={`${index}-${line}`}
          lineClamp={2}
        >
          <TextV2
            typographyVariant="label2"
            color="mono12"
          >
            {line}
          </TextV2>
        </TextEllipsisWrapper>
      ))}
    </Flex>
  );
});

CustomInfo.displayName = 'HotelTile.CustomInfo';
